import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';

export class RecaptchaBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('recaptcha');
    }

    protected installBehaviour(element: HTMLElement): void {
        const captchaConfig: any = Utils.getObjectByAttributes(
            this.tag,
            element,
            null,
            {}
        );

        switch (captchaConfig.captchatype) {
            case 'Yandex': {
                if (!window.smartCaptcha) {
                    return;
                }
                window.smartCaptcha.render(captchaConfig.selector, {
                    sitekey: window.globalAppSettings.captcha.key,
                    callback: (token) => {
                        this.setRecaptchaValueAndRevalidate(
                            captchaConfig.resultselector,
                            token
                        );
                        if (captchaConfig.callback) {
                            Utils.runFunctionByName(captchaConfig.callback, null, [token]);
                        }
                    },
                });
                break;
            }
            case 'GoogleV3':
            case 'GoogleV2':
                {
                    if (!window.grecaptcha) console.error('Объект window.grecaptcha вообще отсутствует на странице. Проверьте подключение скрипта.');
                    window.grecaptcha.ready(() => {
                        window.grecaptcha.render(captchaConfig.selector, {
                            sitekey: captchaConfig.publickey,
                            callback: (code) => {
                                this.setRecaptchaValueAndRevalidate(
                                    captchaConfig.resultselector,
                                    code
                                );
                                if (captchaConfig.callback) {
                                    Utils.runFunctionByName(captchaConfig.callback, null, [code]);
                                }
                            },
                            size: captchaConfig.size,
                            'expired-callback': () => {
                                this.setRecaptchaValueAndRevalidate(
                                    captchaConfig.resultselector,
                                    null
                                );
                            },
                        });
                    });
                    break;
                }
        }
    }

    private setRecaptchaValueAndRevalidate(selector, code) {
        const input: any = $(selector)[0];

        if (input) {
            $(input).val(code);

            const form = input.form;
            const validator = (<any>$(form)).validate();
            validator.element(input);
        }
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.RecaptchaBehaviour = RecaptchaBehaviour;